import {
  GridColDef,
  GridColumnGroupingModel,
  GridValidRowModel
} from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { UseRosterDataGridParams } from '../types';
import { useRosterTimelineColumns } from './useRosterTimelineColumns/useRosterTimelineColumns';

export const useRosterDataGrid = <
  R extends GridValidRowModel = GridValidRowModel,
  V extends string = never
>({
  rosterDays,
  timelineView,
  fixedColumnsLeft,
  fixedColumnsRight,
  renderTimelineCell,
  timelineColumnWidth,
  timelineRelativeStartDate
}: UseRosterDataGridParams<R, V>): {
  columns: GridColDef[];
  columnGroupingModel: GridColumnGroupingModel;
} => {
  const { timeLineColumns, columnGroupingModel } = useRosterTimelineColumns<
    R,
    V
  >({
    rosterDays,
    timelineView,
    renderTimelineCell,
    timelineColumnWidth,
    timelineRelativeStartDate
  });

  const columns = useMemo(
    () => [
      ...applyFixedColumnDefaults(fixedColumnsLeft),
      ...timeLineColumns,
      ...applyFixedColumnDefaults(fixedColumnsRight)
    ],
    [fixedColumnsLeft, timeLineColumns, fixedColumnsRight]
  );

  return { columns, columnGroupingModel };
};

const applyFixedColumnDefaults = <
  R extends GridValidRowModel = GridValidRowModel
>(
  columns?: GridColDef<R>[]
): GridColDef<R>[] =>
  columns?.map(
    (col) =>
      ({
        width: 200,
        sortable: false,
        disableColumnMenu: true,
        ...col
      }) as GridColDef<R>
  ) || [];
